/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetTokensUnderManagementSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetTokensUnderManagementRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetTokensUnderManagementSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetTokensUnderManagementSecurity$outboundSchema: z.ZodMiniType<
  GetTokensUnderManagementSecurity$Outbound,
  GetTokensUnderManagementSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getTokensUnderManagementSecurityToJSON(
  getTokensUnderManagementSecurity: GetTokensUnderManagementSecurity,
): string {
  return JSON.stringify(
    GetTokensUnderManagementSecurity$outboundSchema.parse(
      getTokensUnderManagementSecurity,
    ),
  );
}

/** @internal */
export type GetTokensUnderManagementRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetTokensUnderManagementRequest$outboundSchema: z.ZodMiniType<
  GetTokensUnderManagementRequest$Outbound,
  GetTokensUnderManagementRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getTokensUnderManagementRequestToJSON(
  getTokensUnderManagementRequest: GetTokensUnderManagementRequest,
): string {
  return JSON.stringify(
    GetTokensUnderManagementRequest$outboundSchema.parse(
      getTokensUnderManagementRequest,
    ),
  );
}
